import { createSelector } from 'reselect';
var rootCustomFields = function rootCustomFields(store) {
  return store.custom_fields;
};
export var customFieldsNewFieldsSelector = createSelector(rootCustomFields, function (custom_fields) {
  return custom_fields.new_fields;
});